import Vue from 'vue'
import Vuex from 'vuex'

import {getField, updateField} from 'vuex-map-fields'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state:{
        //general
        currentNav:'front',
        username:'',
        oldpassword:'',
        loggedInUser:{
            id:0,
            name:'',
        },
        securityAppName:'MobileIDAdmin',
        securityAppItems:[],
        loggedIn:false,
        token:null,
        didFailAuth:false,
        storeLogin:false,
        
        badgeData:{},
        logoOverride:'',
        configOverride:'',
        locations:[],
        departments:[],
        alertTemplateList:[],
        personRoleList:[],
        messageTemplateList:[],
        smsTemplateList:[],
        showHeader:true,
        showHeaderFromURL:true,

         //trial and tutorial
        applicationMode:'full',
        inTutorial:false,
        showTutorial:false,
        
        tutorialItems:[],
        tutorialIndex:1,
        tutorialMaxIndex:1,
        tutorialFirstStep:1,
        tutorialLastStep:1
    },
    mutations:{
        updateField,
        failAuth(state){
            state.loggedIn=false;
            state.didFailAuth=true;
        },
    },
    getters:{
        getField,
    },
    actions:{
        failedAuthLogout(context){
            context.commit('failAuth'); 
        },
    }
})